import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { Box } from "@mui-wrapper";

/** Renders the tooltip for the HoloBuilder sidebar item */
export function NewCreditTooltip() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      padding: "12px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={t0}><Text variant="heading12" sx={{
        textTransform: "uppercase",
        marginBottom: "10px",
        display: "block"
      }}>Balance not updated yet.</Text><Text variant="bodyS">Your purchased tokens will be available shortly.</Text></Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}